import '@fortawesome/fontawesome-free/css/all.css';
import "@src/assets/js/exceptions";
import { appendLink } from "@src/assets/js/utils";
export default async function (ctx) {
    (async function () {
        appendLink("https://unpkg.com/flag-icon-css@3.4.5/css/flag-icon.min.css");
        appendLink("https://unpkg.com/please-wait@0.0.5/build/please-wait.css");
    })();
}
const originalConsoleLog = console.log;
if (!process.client) {
    console.log = notObjectsLog;
    console.warn = notObjectsLog;
    console.error = notObjectsLog;
}
function notObjectsLog() {
    const args = [];
    for (const argument of arguments) {
        if ("string" != typeof argument && "number" != typeof argument && "boolean" != typeof argument) {
            continue;
        }
        args.push(argument);
    }
    originalConsoleLog(...args);
}
